export default "__VITE_ASSET__CTWk35Lw__"